<template>
  <div>
    <header class="entete mgb-20px">
      <div class="level">
        <div class="level-left"></div>
        <div class="level-right">
          <button class="button is-addOrEdit" @click="addService()">
            {{ $t('serviceUtilisateur.actions.addServiceUtilisateur')}}
          </button>
        </div>
      </div>
    </header>
    <v-client-table
      v-model="utilisateur.services"
      :columns="columns"
      :options="options"
      :ref="referenceTable">
      <template #code="{ row }">
        {{ row.code }}
      </template>
      <template #nomCommercial="{ row }">
        {{ row.nomCommercial }}
      </template>
      <template #archive="{ row }">
        {{ row.archive ? $t('general.oui') : $t('general.non') }}
      </template>
      <template #delete="{ row }">
        <div class="has-text-centered">
          <btn-action-icon
            :permission="perm.maj"
            @is-click="deleteService(row)"
            icon-type="is-danger"
            icon="delete-forever">
          </btn-action-icon>
        </div>
      </template>
    </v-client-table>
    <b-modal
      :active="popUpAddService"
      @close="popUpAddService = false"
      class="modal"
      width="600px"
      has-modal-card>
      <pop-up-add-service
        :utilisateur="utilisateur"
        @updateServices="updateServiceUtilisateur"/>
    </b-modal>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import { SERVICE } from '@/configuration/general/permissionsParametrageConf';
import { REFERENCE_TABLE_SERVICE_UTILISATEUR } from '@/configuration/general/referenceTableConf';
import BtnActionIcon from '@/components/general/btnActionIcon';
import PopUpAddService from '@/components/parametrage/utilisateur/popUpAddService';

export default {
  name: 'ServiceUtilisateur',
  props: {
    utilisateur: {
      type: Object,
      required: true,
    },
  },
  components: {
    BtnActionIcon,
    PopUpAddService,
  },
  data() {
    return {
      perm: SERVICE,
      referenceTable: REFERENCE_TABLE_SERVICE_UTILISATEUR,
      popUpAddService: false,
    };
  },
  computed: {
    columnsData() {
      return [
        { name: 'code', sortable: true },
        { name: 'nomCommercial', sortable: true },
        { name: 'archive', sortable: true },
        { name: 'delete', sortable: false },
      ];
    },
    columns() {
      return this.columnsData.map((column) => column.name);
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      const headings = this.columnsData.reduce((acc, column) => {
        const key = `serviceUtilisateur.table.${column.name}`;
        acc[column.name] = this.$te(key) ? this.$t(key) : '';
        return acc;
      }, {});
      const sortable = !this.detail
        ? this.columnsData
          .filter((column) => column.sortable)
          .map((column) => column.name)
        : [];
      return {
        texts,
        headings,
        sortable,
        sortIcon: SORT_ICON,
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        columnsClasses: {
          delete: 'colonneSelected',
        },
      };
    },
  },
  methods: {
    addService() {
      this.popUpAddService = true;
    },
    deleteService(row) {
      const { services } = this.utilisateur;
      this.utilisateur.services = services.filter(el => {
        return el.id !== row.id;
      });
      this.updateServiceUtilisateur();
    },
    updateServiceUtilisateur() {
      const newIds = this.utilisateur.services.map(service => service.id);
      this.utilisateur.servicesId = [];
      this.utilisateur.servicesId.push(...newIds);
    },
  },
};
</script>
